module.exports = __webpack_public_path__ + "static/media/option11.e99af55f.png";